export const getOrganization = (state) => state?.organization;

export const getOrganizationPaymentInfos = (state) => state?.organization?.attributes?.payment_info;

export const getOrganizationDocuments = (state) => state?.documents?.map(({ attributes, id }) => ({
  id,
  uploaded_at: attributes?.uploaded_at,
  name: attributes?.name,
  url: attributes?.url,
}));

export const getOrganizationSettings = (state) => state?.settings;
